export default __webpack_public_path__ + "static/media/icon-coin-gno.891a4086.svg";